
export const ID = 'router';

export default ID;
